import { render, staticRenderFns } from "./PharmacyMedicinePickerComponent.vue?vue&type=template&id=b38d3e24&"
import script from "./PharmacyMedicinePickerComponent.vue?vue&type=script&lang=ts&"
export * from "./PharmacyMedicinePickerComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PharmacyMedicinePickerComponent.vue?vue&type=style&index=0&id=b38d3e24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports